export const TOGGLE_ABOUT_MODAL = 'content/TOGGLE_MODAL'
export const TOGGLE_RULES_MODAL = 'content/TOGGLE_RULES_MODAL'
export const TOGGLE_LOGIN_MODAL = 'content/TOGGLE_LOGIN_MODAL'
export const TOGGLE_PASSWORD_MODAL = 'content/TOGGLE_PASSWORD_MODAL'
export const HIDE_LOGIN_MODAL = 'content/HIDE_LOGIN_MODAL'
export const HIDE_PASSWORD_MODAL = 'content/HIDE_PASSWORD_MODAL'
export const SHOW_PASSWORD_RESET_TOKEN = 'content/SHOW_PASSWORD_RESET_TOKEN'

let initialState = {
	showAboutModal: false,
	showRulesModal: false,
	showLoginModal: false,
	showPasswordModal: false,
	showPasswordResetToken: false,
}

export default (state = initialState, action) => {
	switch (action.type) {
		case TOGGLE_ABOUT_MODAL:
			return {
				...state,
				showAboutModal: !state.showAboutModal,
			}

		case TOGGLE_RULES_MODAL:
			return {
				...state,
				showRulesModal: !state.showRulesModal,
			}

		case TOGGLE_LOGIN_MODAL:
			return {
				...state,
				showLoginModal: !state.showLoginModal,
			}

		case TOGGLE_PASSWORD_MODAL:
			return {
				...state,
				showPasswordModal: !state.showPasswordModal,
				showPasswordResetToken: false
			}

		case SHOW_PASSWORD_RESET_TOKEN:
			return {
				...state,
				showPasswordResetToken: true,
			}

		case HIDE_LOGIN_MODAL:
			return {
				...state,
				showLoginModal: false,
			}

		case HIDE_PASSWORD_MODAL:
			return {
				...state,
				showPasswordModal: false,
				showPasswordResetToken: false
			}

		default:
			return state
	}
}

export const toggleModal = (type) => {
	return (dispatch, getState) => {
		switch(type){
			case 'about':
				return dispatch({type: TOGGLE_ABOUT_MODAL})
			case 'rules':
				return dispatch({type: TOGGLE_RULES_MODAL})
			case 'login':
				return dispatch({type: TOGGLE_LOGIN_MODAL})
			case 'password':
				return dispatch({type: TOGGLE_PASSWORD_MODAL})
			default:
				return;
		}
	}
}